export const da = {
  setupGuide: "Opsætningsguide",
  createPostNordAccount: "Opret PostNord konto",
  createPostNordDesc: "For at bruge PostNord Shipping, skal du have en PostNord konto.",
  goTo: "Gå til",
  customerPortal: "kundeportalen",
  toCreateAccount: "for at oprette konto",
  inputCustomerNumber: "Indtast PostNord kundenummer",
  inputCustomerNumberDesc: "Du finder dit kundenummer i kundeportalen under indstillinger.",
  yourCustomerNumber: "Dit kundenummer",
  next: "Næste",
  deliveryRates: "Leveringspriser",
  deliveryRatesDesc:
    "Levering med PostNord kan foregå til hjemmeadresse (MyPack Home) eller til udleveringssted i nærheden (MyPack Collect). Angiv herunder pris for hver leveringstype.",
  submitSetupTitle: 'Gennemfør opsætning',
  submitSetupDesc:
    'Sidste del kræver opsætning hos PostNord. Den del klarer vi for dig, så du skal blot trykke "Gennemfør opsætning". Du vil få en email når opsætningen er afsluttet, hvorefter PostNord Shipping er klar til brug.',
  submitSetupButton: "Gennemfør opsætning",
  setupCompletionPending: 'Vi behandler nu din konto',
  setupCompletionPendingDesc: 'Du vil få en email når opsætningen er afsluttet, hvorefter PostNord Shipping er klar til brug. Forvent behandlingstid på 1-3 hverdage. Email sendes til:'
};

export const en = {
  setupGuide: "Setup guide",
  createPostNordAccount: "Create PostNord account",
  createPostNordDesc: "You must have a PostNord account to use PostNord Shipping.",
  goTo: "Go to",
  customerPortal: "customer portal",
  toCreateAccount: "to create account",
  inputCustomerNumber: "Input PostNord customer number",
  inputCustomerNumberDesc: "Find your customer number in customer portal under Settings",
  yourCustomerNumber: "Your customer number",
  next: "Next",
  deliveryRates: "Delivery rates",
  deliveryRatesDesc: "PostNord delivers to home address (MyPack Home) or collection point nearby (MyPack Collect). Input delivery rate for each type.",
  submitSetupTitle: 'Process account',
  submitSetupDesc:
    'Last part requires some PostNord setup. We will handle that part for you, so you just need to press "Process account". You will receive an email when setup is complete, at which point PostNord Shipping will be ready for use.',
  submitSetupButton: "Process account",
  setupCompletionPending: 'We are now processing your account',
  setupCompletionPendingDesc: 'You will receive an email when setup is complete, at which point PostNord Shipping will be ready for use. Expect completion in 1-3 business days. Email will be sent to:'
};
